import { EventEmitterBase } from './event-emitter-base';

export class Counter extends EventEmitterBase {

    private _value: number = 0;

    value(): number {
        return this._value;
    }

    reset(): void {
        this._value = 0;
    }

    increment(val: number = 1): void {
        if (val !== 0) {
            const tmp: number = this._value;
            this._value += val;
            this.emit('valueChange', {
                oldValue: tmp,
                newValue: this._value,
            });
        }
    }

    decrement(val: number = 1): void {
        if (val !== 0) {
            const tmp: number = this._value;
            this._value += val;
            this.emit('valueChange', {
                oldValue: tmp,
                newValue: this._value,
            });
        }
    }

}
